import { render, staticRenderFns } from "./TestimonialInvoiceHandler.vue?vue&type=template&id=585eaabe&scoped=true&"
import script from "./TestimonialInvoiceHandler.vue?vue&type=script&lang=js&"
export * from "./TestimonialInvoiceHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585eaabe",
  null
  
)

export default component.exports